export default "__VITE_ASSET__BvmynLRK__"